import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, unref as _unref, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '@/assets/bot_express_logo.png'


const _hoisted_1 = { class: "min-h-screen bg-zinc-900 flex flex-col items-center justify-center p-4 font-nunito" }
const _hoisted_2 = { class: "w-full max-w-md" }
const _hoisted_3 = { class: "bg-white/5 rounded-xl overflow-hidden" }
const _hoisted_4 = { class: "p-6" }
const _hoisted_5 = { class: "space-y-3 mb-6" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "flex items-center justify-between" }
const _hoisted_8 = { class: "flex items-center space-x-3" }
const _hoisted_9 = { class: "flex-shrink-0 w-10 h-10 bg-gradient-to-br from-amber-500 to-orange-600 rounded-full flex items-center justify-center text-white font-bold" }
const _hoisted_10 = { class: "text-white font-medium" }
const _hoisted_11 = { class: "text-zinc-400 text-sm" }

import { useOrganization } from '@/composables/useOrganization'
import { Organization } from '@/interfaces/organizations/Organization'
import router from '@/router'
import { Loader2 } from 'lucide-vue-next'
import { onMounted, ref } from 'vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'OrganizationView',
  setup(__props) {

const organizations = ref<Organization[]>()
const { getAll, chooseOrganization } = useOrganization()

const continueToApp = (organization: Organization) => {
  chooseOrganization(organization)
  router.push({ name: 'home' })
}

onMounted(() => {
  getAll().then((data) => {
    organizations.value = data
  })
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[2] || (_cache[2] = _createElementVNode("div", { class: "flex items-center mb-10" }, [
      _createElementVNode("img", {
        src: _imports_0,
        alt: "Logo",
        class: "h-auto w-[180px] sm:w-[280px]"
      })
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _cache[1] || (_cache[1] = _createElementVNode("div", { class: "mb-6 text-center" }, [
            _createElementVNode("h2", { class: "text-white text-xl font-bold tracking-tight" }, "Escolha uma Organização"),
            _createElementVNode("p", { class: "text-zinc-400 text-sm mt-1" }, "Selecione uma organização para continuar")
          ], -1)),
          _createElementVNode("div", _hoisted_5, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(organizations.value, (organization) => {
              return (_openBlock(), _createElementBlock("div", {
                key: organization.id,
                class: "relative bg-white/5 hover:bg-white/10 border border-zinc-700 rounded-lg p-4 transition-all duration-200 cursor-pointer group",
                onClick: ($event: any) => (continueToApp(organization))
              }, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, _toDisplayString(organization.name.charAt(0).toUpperCase()), 1),
                    _createElementVNode("div", null, [
                      _createElementVNode("h3", _hoisted_10, _toDisplayString(organization.name), 1),
                      _createElementVNode("p", _hoisted_11, _toDisplayString(organization.document), 1)
                    ])
                  ]),
                  _cache[0] || (_cache[0] = _createStaticVNode("<div class=\"flex items-center space-x-2\"><div class=\"w-8 h-8 rounded-full bg-white/5 flex items-center justify-center transition-colors text-zinc-400 group-hover:text-white\"><svg xmlns=\"http://www.w3.org/2000/svg\" width=\"16\" height=\"16\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"m2 4 3 12h14l3-12-6 7-4-7-4 7-6-7zm3 16h14\"></path></svg></div><div class=\"w-8 h-8 rounded-full bg-[#10B981]/10 flex items-center justify-center text-[#10B981] group-hover:bg-[#10B981] group-hover:text-white transition-colors\"><svg xmlns=\"http://www.w3.org/2000/svg\" width=\"16\" height=\"16\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"m9 18 6-6-6-6\"></path></svg></div></div>", 1))
                ])
              ], 8, _hoisted_6))
            }), 128)),
            (!organizations.value)
              ? (_openBlock(), _createBlock(_unref(Loader2), {
                  key: 0,
                  class: "w-10 h-10 animate-spin text-white mx-auto"
                }))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ])
  ]))
}
}

})